import { ButtonInput } from "../shared/Inputs/ButtonInput";
import { TextInput } from "../shared/Inputs/TextInput";
import { ISetting, SettingInputType } from "../../models/Setting";
import { TextInputHidden } from "../shared/Inputs/TextInputHidden";
import { NumberInputHidden } from "../shared/Inputs/NumberInputHidden";
import { Controller, useForm } from "react-hook-form";
import useSettings from "../../data/useSettings";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";

type FormValues = {
  value: string;
};

export default function AdminSettingsValue({ setting }: { setting: ISetting }) {
  console.log("Setting details", setting);
  const { update } = useSettings();
  const { saveHandlers } = useDefaultCRUDHandlers("Admin Settings");
  const { register, handleSubmit, control } =
    useForm<FormValues>({
      defaultValues: {
        value: setting.value,
      },
    });


  const onSubmit = (data: FormValues) => {
    console.log(setting);

    const updatedSetting = {
      ...setting,
      value: data.value,
    };

    update.mutate(updatedSetting, saveHandlers);
  }

  function renderInputByType() {
    switch (setting.inputType) {
      case SettingInputType.Toggle:
        return (
          <div className="flex items-center">
            <Controller
              name="value"
              control={control}
              render={({ field }) => (
                <>
                  <input
                    type="checkbox"
                    checked={field.value === "true"}
                    onChange={(e) => field.onChange(e.target.checked ? "true" : "false")}
                    className="h-5 w-5 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                  />
                  <label className="ml-2 block text-xs text-gray-400">{field.value === "true" ? "(true)" : "(false)"}</label>
                </>
              )}
            />
          </div>
        );
      case SettingInputType.Number:
        return (
          <div className="w-8/12 md:w-1/2">
            <NumberInputHidden label={null} register={register} registerName="value" />
          </div>
        );
      default: // TEXT INPUT
        return (
          <div className="w-8/12 md:w-1/2">
            <TextInputHidden label={null} register={register} registerName="value" />
          </div>
        )
    }
  }
  return (
    <form className="flex justify-between" onSubmit={handleSubmit(onSubmit)}>
      {renderInputByType()}
      <ButtonInput label={"Update"} isSubmit={true} onClick={undefined} classes={undefined} />
    </form>
  )

}